import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const accountManagementAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ApprovalsManagementAdmin],
}
